import Paragraph from "antd/es/typography/Paragraph";
import { whiteTextStyle } from "../constants/style";
import Menu from "./master/menu";

export default function () {
  return (
    <Menu title="Privacy Policy">
      <Paragraph style={whiteTextStyle}>TBD</Paragraph>
    </Menu>
  );
}